export default "__VITE_ASSET__8dc45318__"